// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"1f939622","557":"0fdff5be","925":"462f9d04"}[chunkId] + ".chunk.js";
};